import { GenericServiceBase } from "../generic-service";

export class AdminAuthService extends GenericServiceBase {
    constructor() { super('admin-auth') }

    async isLoggedIn() {
      return await this.f.get('/isLoggedIn', undefined, {returnBooleanForLogin: true}) as boolean;
    }

    async login(email:string, senha:string) {
        return await this.f.post('/login', { email, senha }, {doNotRedirectOn401: true});
    }

    async logout() {
        return await this.f.post('/logout');
    }

    async refreshToken() {
        return await this.f.get('/refresh-token');
    }

    async whoAmI(): Promise<{ id: string; nome: string; email: string; root: boolean } | false> {
      try {
        return await this.f.get('/who-am-i') as { id: string; nome: string; email: string; root: boolean };
      } catch {
        return false;
      }
    }
}